export const Descuento = {
  MontoDescuento: 0,
  NaturalezaDescuento: ''
}